export default "__VITE_ASSET__TN4i_k1x__"